module.exports = __webpack_public_path__ + "img/theme-6-green.88500c34.svg";